import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FocusTrapService {
  returnElementSubject = new Subject<HTMLElement>();

  returnElement$ = this.returnElementSubject.asObservable();

  emitReturnFocus(returnFocus: HTMLElement) {
    this.returnElementSubject.next(returnFocus);
  }
}